/***********************************
*   popup.js
*   Generic popup containers (Popup, PopupLit) shared by the main portal
*   (display_type_views.js) and the login page (login.js). Extracted so the
*   login bundle does not have to pull in the full display_type_views module.
*   Relies on globals provided before module scripts run: Backbone, jQuery ($),
*   underscore (_), window.LitLite, and window.DplLink.
************************************/
(function () {
    "use strict";

    DplLink.Popup = Backbone.View.extend({
        tagName: "div",
        className: "tooltippop",
        events: {
            'click .popupClose': 'hide',
            'click': 'popupClick',
            'click .ic-cancel': 'hide'
        },
        initialize: function (options) {
            options = options || {};
            //this.$el.hide();
            this.propagateEvents = false;
            this.attachTo = options.attachTo || $('body');
            this.overlayEnabled = options.overlayEnabled;
            this.shown = false;
            this.topBar = options.topBar || false;
        },
        // Content is either a jQuery element, LitLite class, or Backbone view.
        show: function (content, position, timeout, css) {
            if (this.overlayEnabled) {
                this.attachTo.append('<div id="popup-overlay"></div>');
            }
    
            this.attachTo.append(this.el);
            let contentEl;
    
            if (content instanceof Backbone.View) {
                this.bbview = content;
                contentEl = this.bbview.render().el;
            } else if (content instanceof LitLite) {  // Handle LitLite instance
                this.bbview = content;
                contentEl = content.el;  // Use the `el` property directly
            } else {
                this.bbview = null;
                contentEl = $(content);
            }
    
            clearTimeout(this.timer);
    
            if (css != null && css != undefined) {
                this.$el.css(css);
            } else {
                this.$el.css({
                    top: 0,
                    left: 0,
                    width: 'auto'
                });
            }
    
            this.$el.empty();
            if (this.topBar) {
                this.$el.append('<div class="ic-cancel"></div>');
            }
    
            this.$el.append(contentEl);
    
            this.$el.show();
    
            if (position) {
                this.$el.position(position);
                this.position = position;
            } else {
                this.$el.position({
                    my: 'center',
                    at: 'center',
                    of: window,
                    collision: 'fit'
                });
            }
    
            if (!timeout) {
                timeout = Math.max(1000 * $(contentEl).html().length / 12, 7000);
            }
            if (timeout !== 'never' && !this.topBar) {
                this.timer = setTimeout(_.bind(this.hide, this), timeout);
            }
    
            this.shown = true;
        },
        hide: function () {
            if (this.overlayEnabled) {
                this.attachTo.find('#popup-overlay').remove();
            }
            if (this.bbview) {
                this.bbview.destroy();  // Ensure destruction of Backbone or LitLite view
            }
            this.$el.empty();
            this.$el.detach();
    
            this.shown = false;
        },
        popupClick: function (e) {
            if (!this.propagateEvents) {
                e.stopImmediatePropagation();
            }
        },
        reposition: function () {
            if (this.position) {
                this.$el.position(this.position);
            }
        },
        recenter: function () {
            this.$el.position({
                my: 'center',
                at: 'center',
                of: window,
                collision: 'fit'
            });
        }
    });
    

    class PopupLit {
        constructor(options = {}) {
            this.el = document.createElement('div');
            this.el.className = 'tooltippop';
            this.attachTo = options.attachTo || document.body;
            this.overlayEnabled = options.overlayEnabled || false;
            this.topBar = options.topBar || false;
            this.shown = false;
            this.position = null;
        }
    
        show(content, position, timeout, css) {
            if (this.overlayEnabled) {
                const overlay = document.createElement('div');
                overlay.id = 'popup-overlay';
                this.attachTo.appendChild(overlay);
            }
    
            this.attachTo.appendChild(this.el);
    
            let contentEl;
    
            if (content instanceof LitLite) {
                contentEl = content.el;  // Use the root element of the LitLite component
            } else if (content instanceof HTMLElement) {
                contentEl = content;
            } else {
                contentEl = document.createElement('div');
                contentEl.innerHTML = content;
            }
    
            this.el.innerHTML = '';  // Clear existing content
            if (this.topBar) {
                const closeButton = document.createElement('div');
                closeButton.className = 'ic-cancel';
                closeButton.addEventListener('click', () => this.hide());
                this.el.appendChild(closeButton);
            }
    
            this.el.appendChild(contentEl);  // Append content to the popup
    
            if (css) {
                Object.assign(this.el.style, css);
            } else {
                this.el.style.top = '0';
                this.el.style.left = '0';
                this.el.style.width = 'auto';
            }
    
            if (position) {
                $(this.el).position(position);  // jQuery position
                this.position = position;
            } else {
                $(this.el).position({
                    my: 'center',
                    at: 'center',
                    of: window,
                    collision: 'fit'
                });
            }
    
            if (timeout && timeout !== 'never') {
                this.timer = setTimeout(() => this.hide(), timeout);
            }
    
            this.shown = true;
        }
    
        hide() {
            if (this.overlayEnabled) {
                const overlay = document.getElementById('popup-overlay');
                if (overlay) {
                    overlay.remove();
                }
            }
    
            this.el.innerHTML = '';
            this.attachTo.removeChild(this.el);
            this.shown = false;
        }
    
        recenter() {
            if (this.position) {
                $(this.el).position(this.position);
            } else {
                $(this.el).position({
                    my: 'center',
                    at: 'center',
                    of: window,
                    collision: 'fit'
                });
            }
        }
    }
      
      customElements.define('dpl-popup-lit', PopupLit);
      DplLink.PopupLit=PopupLit;


    /***********************************
    *   Global Popup
    *   Single use popup (one at a time) "I" help
    ************************************/
    DplLink.popupSingleton = null;
    DplLink.GlobalPopup = {
        show: function (content, position, timeout) {
            if (DplLink.popupSingleton == null) {
                DplLink.popupSingleton = new DplLink.Popup();
            }

            DplLink.popupSingleton.show(content, position, timeout);
        },
        hide: function () {
            if (DplLink.popupSingleton) {
                DplLink.popupSingleton.hide();
            }
        },
        reposition:function () {
            if (DplLink.popupSingleton) {
                DplLink.popupSingleton.reposition();
            }
        }
    };


    /***********************************
    *   Network Msg Popup
    *   Network (save) display (green dialog)
    ************************************/
    DplLink.NetworkMsgPopupSingleton = null;
    DplLink.NetworkMsgPopup = {
        show: function (content, type, timeout) {
            if (DplLink.NetworkMsgPopupSingleton == null) {
                DplLink.NetworkMsgPopupSingleton = new DplLink.Popup();
            }

            DplLink.NetworkMsgPopup.contentList.push(content);

            content = $('<div class="networkMsgPopup">' + DplLink.NetworkMsgPopup.contentList.join('<br/>') + '</div>');
            content.addClass(type);

            DplLink.NetworkMsgPopupSingleton.show(content, {
                my: 'top',
                at: 'top+10px',
                of: window,
                collision: 'fit'
            }, timeout);

            setTimeout(()=>{DplLink.NetworkMsgPopup.contentList.shift();},timeout);
        },
        hide: function () {
            if (DplLink.NetworkMsgPopupSingleton) {
                DplLink.NetworkMsgPopupSingleton.hide();
            }
        },
        contentList:[]
    };



    /***********************************
    *   datatag Mgmt Popup
    * 
    ************************************/
    DplLink.datatagMgmtSingleton = null;
    DplLink.datatagMgmtPopup = {
        show: function (content, position, timeout) {
            if (DplLink.datatagMgmtSingleton == null) {
                DplLink.datatagMgmtSingleton = new DplLink.Popup();
                $('body').append(DplLink.datatagMgmtSingleton.el);
            }

            DplLink.datatagMgmtSingleton.show(content, position, timeout);
        },
        hide: function () {
            if (DplLink.datatagMgmtSingleton) {
                DplLink.datatagMgmtSingleton.hide();
            }
        }
    };

})();
